import montantTools from "../../../../helpers/montantTools";
import ligneDevisTools from "../../../../helpers/ligneDevisTools";

const { lireMontant, lireMontantOptionnel, estVide } = montantTools;
// Options facultatives : vidées, elles valent 0 ; illisibles, elles bloquent.
const { OPTIONS } = ligneDevisTools;

const erreurLigne = (q) => {
  if (parseFloat(q.repurchaseValueFinal) <= 0) {
    return "La valeur de rachat est manquante";
  }
  if (
    parseFloat(q.maintenanceValueFinal) < 0 ||
    q.maintenanceValueFinal + "" === ""
  ) {
    return `La valeur de maintenance est manquante (${q.maintenanceValueFinal})`;
  }
  // Sans ces deux paramètres, le loyer financier tombe à 0 sans que le total
  // le montre : la ligne s'enregistrait avec un loyer faux.
  if (!(lireMontant(q.financeRate) > 0)) {
    return "Le taux de financement est vide ou invalide";
  }
  if (!(lireMontant(q.applicationFee) >= 0)) {
    return "Les frais de dossier sont vides ou invalides";
  }
  if (!estVide(q.firstRentInput) && isNaN(lireMontant(q.firstRentInput))) {
    return "L'apport 1er loyer est invalide";
  }
  if (isNaN(lireMontant(q.marginTTC))) {
    return "La marge TTC est vide ou invalide";
  }
  const option = OPTIONS.find(({ champ }) =>
    isNaN(lireMontantOptionnel(q[champ])),
  );
  if (option) {
    return `Le montant « ${option.libelle} » est invalide`;
  }
  if (parseInt(q.totalRentHT) <= 0) {
    return "Le loyer semble erroné";
  }
  return null;
};

// Première ligne du dossier qui empêche l'enregistrement, numérotée à partir de 1.
export const controlerLignesDevis = (quotations) => {
  for (let index = 0; index < quotations.length; index++) {
    const q = quotations[index];
    const erreur = erreurLigne(q);
    if (erreur) {
      return {
        index,
        message: `${erreur} pour le dossier N°${index + 1} - ${q.reference}`,
      };
    }
  }
  return null;
};
